import { Link } from 'react-router-dom';
import { PHONE_DISPLAY, PHONE_TEL } from '@/components/LandingNav';

/**
 * Minimal compliance-only footer used on paid-traffic landing pages.
 * Privacy + Terms required for Google/Meta ads policy.
 */
export default function LandingFooter() {
  return (
    <footer
      className="border-t border-[hsl(var(--border))] py-6"
      data-testid="landing-footer"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--brand-slate-500)]">
        <p>
          © {new Date().getFullYear()} Snap Windows. Licensed & insured South Florida contractor.
        </p>
        <div className="flex items-center gap-4">
          <Link to="/privacy-policy" className="hover:text-[var(--brand-slate-800)]">
            Privacy
          </Link>
          <Link to="/terms-of-service" className="hover:text-[var(--brand-slate-800)]">
            Terms
          </Link>
          <a href={PHONE_TEL} className="hover:text-[var(--brand-slate-800)]">
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </footer>
  );
}
